import '../../scss/components/link.scss';
import BlueprintComponent from '../core/blueprintComponent';
/** The name of the module */
export const name = 'Link';
/** Class names for Links */
export var ClassNames;
(function (ClassNames) {
    ClassNames["Default"] = "bp-c-link";
    ClassNames["JavaScript"] = "js-link";
})(ClassNames || (ClassNames = {}));
class Link extends BlueprintComponent {
    /**
       * Create a Link HTML element
       *
       * @param url Url to populate the href attribute
       * @param options Options for building the element
       */
    static createElement(url, options) {
        // Create the element and set the basics
        const element = document.createElement('a');
        element.href = url;
        element.classList.add(ClassNames.Default);
        // Add any additional class names
        if (options.classNames && options.classNames.length) {
            element.classList.add(...options.classNames);
        }
        // Set link to open in a new tab/window if requested
        if (options.targetNewWindow) {
            element.setAttribute('target', '_blank');
        }
        else if (options.target) {
            element.setAttribute('target', options.target);
        }
        // If content is supplied, then add it to the element
        if (options.content) {
            if (typeof options.content === 'string') {
                element.appendChild(document.createTextNode(options.content));
            }
            else {
                element.appendChild(options.content);
            }
        }
        return element;
    }
}
export default Link;
